import isEmpty from 'lodash.isempty'

const FILE_EXTENSIONS = [ 'jpeg', 'jpg', 'gif', 'png', 'apng', 'svg', 'bmp', 'ico', 'css' ]
const FILE_SIZE_LIMIT = 25000000 //25 MB
const IMAGE_EXTENSIONS = [ 'jpeg', 'jpg', 'gif', 'png', 'apng', 'svg', 'bmp', 'ico' ]
export const ALLOWED_MIME_TYPES = [ 'image/jpeg', 'image/gif', 'image/png', 'image/x-png', 'image/apng', 'image/svg+xml', 'image/bmp', 'image/x-icon', 'text/css' ]
export const ALLOWED_FILETYPES = [ ALLOWED_MIME_TYPES, FILE_EXTENSIONS ]


export const isImage = ext => {
  return IMAGE_EXTENSIONS.includes(ext)
}

export const getFileType = file => {
  if (file.type === 'folder') {
    return 'folder'
  }
  if (file.extension) {
    return file.extension.replace('.', '')
  }
  if (file.name) {
    return file.name.split('.').pop().toLowerCase()
  }
  return 'unknown'
}

export const getSelectedFolderId = (selectedFolders, folders) => {
  let id = selectedFolders.id
  if (!id) {
    const selectedFolder = folders[selectedFolders.parentId].files.find(folder => folder.filename === selectedFolders.filename)
    id = selectedFolder && selectedFolder.id
  }
  return id
}

export const isFileRequestPending = (files) => {
  return files.fileRequest && files.fileRequest.status === 'pending'
}

export const isFileUpload = (files) => {
  return files.fileRequest && files.fileRequest.action === 'upload'
}

export const isSingleFileUpload = (files) => {
  return files.fileRequest && files.fileRequest.action === 'upload_single_file'
}

export const isFileRequestedFromMenu = (files) => {
  return files.fileRequest && files.fileRequest.location === 'menu'
}

export const isFolderEmpty = folder => {
  return folder ? folder.files.length === 0 : true
}

export const isFolderOpened = (id, folders) => {
  return folders[id] ? folders[id].status === 'open' : false
}

export const isRefreshPending = (files) => {
  return files.isRefreshPending === true
}

export const isSelected = (selectedFolder, id, filename, parentId) => {
  return (selectedFolder.id && id) ? selectedFolder.id === id :
    (filename === selectedFolder.filename && selectedFolder.parentId === parentId)
}

export const isFileSizeOverLimit = (files) => {
  return files.findIndex(file => file.size > FILE_SIZE_LIMIT) !== -1
}

export const shouldBeExcluded = (folder, excludedFolders) => {
  return excludedFolders ? excludedFolders.findIndex(id => folder.id === id) !== -1 : false
}

export const shouldDisplayEditingField = (newFolder, parentId) => {
  return newFolder && newFolder.parentId === parentId && newFolder.status === 'editing'
}

export const shouldRefreshFolder = (refreshFolder) => {
  return refreshFolder && ('id' in refreshFolder)
}

export const shouldUpdateFilename = (newName, oldName) => {
  return !isEmpty(newName.trim()) && newName !== oldName
}

export const shouldUpdateDescription = (newDescription, oldDescripion) => {
  return newDescription !== oldDescripion
}

export const toAPIParentId = (parentId) => {
  return parentId === 'root' ? '' : parentId
}

export const getCompletedUploadCount = (files) => {
  let count = 0
  files.forEach(file => {
    if (file.status === 'COMPLETE') {
      count++
    }
  })
  return count
}

export const isBulkUploadCompleted = (files) => {
  let complete = true
  for (let i= 0; i < files.length; i++) {
    if (!files[i].status) {
      complete = false
      break
    }
  }
  return complete
}

export const updateUploadFileList = (oldFileList, file, status, fileId) => {
  return oldFileList.map(oldFile => {
    if (file.name === oldFile.name) {
      oldFile.fileId = oldFile.fileId || fileId
      oldFile.status = status
      file = oldFile
    }
    return oldFile
  })
}

export const getUpdatedUploadFile = (file, fileList) => {
  return fileList.find(oldFile => oldFile.name === file.name)
}

export const getSelectedFiles = (files, selections, fileIds) => {
  const selectedIds = selections.files.length > 0 ? selections.files : fileIds
  const rootLevelFiles = files.files && files.files.filter(f => selectedIds.includes(f.id))
  if (isEmpty(rootLevelFiles)) {
    return files.selectedFile && files.selectedFile.files && files.selectedFile.files.filter(f => selectedIds.includes(f.id))
  }
  return rootLevelFiles
}
